import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const SETTINGS = {
  ROOT: `${PRIVATE_ROOT}/setting`,
  ACCOUNT_SETTINGS: `${PRIVATE_ROOT}/setting/account-settings`,
  ADD_PROFILE_PIC: `${PRIVATE_ROOT}/setting/add-profile-pic`,
  EDIT_PERSONAL_INFO: `${PRIVATE_ROOT}/setting/personal-info/edit`,
  LANGUAGE_SETTINGS: `${PRIVATE_ROOT}/setting/language-settings`,
  MODE_SETTINGS: `${PRIVATE_ROOT}/setting/change-mode`,
  PERSONAL_INFO: `${PRIVATE_ROOT}/setting/personal-info`,
  PRIVACY_POLICY: `${PRIVATE_ROOT}/setting/privacy-policy`,
  ROOMMATE_PREFERENCES: `${PRIVATE_ROOT}/setting/roommate-preferences`,
  TAKE_NEW_PHOTO: `${PRIVATE_ROOT}/setting/take-new-photo`,
  TERMS_AND_CONDITIONS: `${PRIVATE_ROOT}/setting/terms-and-conditions`,

  // TWO_FACTOR_AUTH: `${PRIVATE_ROOT}/setting/two-factor-auth`,
  UNIT_PROPERTY_ACCOUNTS: `${PRIVATE_ROOT}/setting/unit-property-accounts`,
  PRIVACY_POLICIES: {
    ROOT: `${PRIVATE_ROOT}/setting/privacy-policies`,
    INFO_REQUEST: `${PRIVATE_ROOT}/setting/privacy-policies/info-request`,
    DELETION_REQUEST: `${PRIVATE_ROOT}/setting/privacy-policies/deletion-request`,
    OTHER_REQUEST: `${PRIVATE_ROOT}/setting/privacy-policies/other-request`,
  },
}
